import SimpleRatingBadge from 'src/components/simple-rating-badge';
import type { RatingOption } from 'src/ratings/ratings';

import SelectFilter from '../filters/SelectFilter';
import { nullDataChartLabel } from '../nullData';
import type { CellInfo, Helpers, ReportFieldType } from './types';

const getRating = ({
  fieldData,
  fieldDef,
  helpers,
}: CellInfo): RatingOption | undefined => {
  if (fieldDef.displayType !== 'rating') {
    throw new Error('rating filed type used out of context');
  }

  return helpers.getRatingByValue(
    fieldDef.ratingKey,
    fieldData.value as number | string
  );
};

export const rating: ReportFieldType = {
  getChartColor(cellData) {
    const rating = getRating(cellData);

    return rating?.color;
  },
  getChartLabel(cellData) {
    const rating = getRating(cellData);

    return rating?.label ?? nullDataChartLabel();
  },
  exportVal: (cellData) => {
    const rating = getRating(cellData);

    if (rating === null || rating === undefined) {
      return '';
    }

    return rating.label;
  },
  cell: function (cellData) {
    const rating = getRating(cellData);

    return <SimpleRatingBadge rating={rating} />;
  },
  propertyConfig(fieldDef, { getRatingByValue, getRatingOptions }: Helpers) {
    if (fieldDef.displayType !== 'rating') {
      throw new Error('rating field type used out of context');
    }

    return {
      key: fieldDef.key,
      groupValuesLabel: fieldDef.groupValuesLabel,
      propertyLabel: fieldDef.propertyLabel,
      operators: ['=', '!='].map((operator) => ({
        operator,
        format: (value) => {
          const rating = getRatingByValue(fieldDef.ratingKey, value);

          return rating?.label ?? '';
        },
        form: (props) => {
          return (
            <SelectFilter
              {...props}
              options={getRatingOptions(fieldDef.ratingKey).map((o) => ({
                value: (o.value as unknown as string) ?? undefined,
                label: o.label,
              }))}
            />
          );
        },
      })),
    };
  },
};
